module.exports = __webpack_public_path__ + "static/media/PB_G_08.eac198cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_08.png
// module id = 221
// module chunks = 0